<template>
  <article class="location-card">
    <div class="location-pin"><v-icon>mdi-map-marker-outline</v-icon></div>
    <div>
      <strong>{{ location.name }}</strong>
      <span>{{ addressLine }}</span>
      <span v-if="detailed && (location.phoneNumber || location.cellNumber)">
        <v-icon x-small>mdi-phone-outline</v-icon> {{ location.phoneNumber || location.cellNumber }}
      </span>
      <span v-if="detailed && location.email">
        <v-icon x-small>mdi-email-outline</v-icon> {{ location.email }}
      </span>
    </div>
    <div class="location-balance">
      <small>Balance</small>
      <strong>{{ Number(location.balance || 0) | currency }}</strong>
    </div>
  </article>
</template>

<script>
export default {
  name: 'PortalLocationCard',
  props: {
    location: { type: Object, required: true },
    detailed: Boolean,
  },
  computed: {
    addressLine() {
      return [this.location.address, this.location.address1, this.location.city, this.location.state, this.location.zip]
        .filter(Boolean)
        .join(', ') || 'No address on file';
    },
  },
};
</script>
